module.exports = __webpack_public_path__ + "assets/img/2_795.13bc696e.jpg";